// extracted by mini-css-extract-plugin
module.exports = {"section_contactus_hero":"hero_section_contactus_hero__WRBj4","title_wrapper":"hero_title_wrapper__H7yze","title":"hero_title__SwptR","sub_text":"hero_sub_text__6XNxP"};